import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

const BadgesPlaceholder = () => {
  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="shrink-0">
        <CardTitle className="text-lg">الإنجازات والشارات</CardTitle>
        <CardDescription>قريباً...</CardDescription>
      </CardHeader>
      <CardContent className="flex-1 overflow-y-auto min-h-0">
        <div className="grid grid-cols-3 gap-3">
          {[...Array(9)].map((_, i) => (
            <div
              key={i}
              className="aspect-square bg-muted rounded-lg flex items-center justify-center text-muted-foreground text-sm font-medium"
            >
              {i + 1}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default BadgesPlaceholder;